import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as e } from "../../../../IconBase-CxZyIWw2.js";
const c = r((l, a) => /* @__PURE__ */ s.jsx(
  e,
  {
    ref: a,
    ...l,
    image: (i) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_3725)", children: [
            /* @__PURE__ */ s.jsxs(
              "mask",
              {
                id: "mask0_2974_3725",
                width: 16,
                height: 16,
                x: 0,
                y: 0,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M11.331 5.625H4.678a.69.69 0 0 0-.683.682c0 .373.31.683.683.683h6.653c.373 0 .683-.31.683-.683a.69.69 0 0 0-.683-.682M11.331 9.02H4.678a.69.69 0 0 0-.683.682c0 .373.31.682.683.682h6.653c.373 0 .683-.309.683-.682a.69.69 0 0 0-.683-.683"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M8 0C3.586 0 0 3.586 0 8s3.586 8 8 8 8-3.586 8-8c.01-4.414-3.586-8-8-8m0 14.635A6.64 6.64 0 0 1 1.365 8 6.64 6.64 0 0 1 8 1.365 6.64 6.64 0 0 1 14.635 8c.009 3.659-2.976 6.635-6.635 6.635"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3725)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_3725", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
        ]
      }
    )
  }
));
c.displayName = "AgencyEqualsIcon";
export {
  c as AgencyEqualsIcon,
  c as default
};
//# sourceMappingURL=index.js.map
